import React, { useEffect, useState } from "react";
import { Carousel, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { formatNumber } from "../utils/numberUtils";

const FeaturedCars = ({ data }) => {
  const [featuredImages, setFeaturedImages] = useState({});
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const fetchFeaturedImages = async () => {
      const images = {};
      for (const car of data) {
        if (car.featured_media) {
          try {
            const mediaResponse = await fetch(
              `https://finditzstg.wpengine.com/wp-json/wp/v2/media/${car.featured_media}`
            );
            const mediaData = await mediaResponse.json();
            images[car.featured_media] = mediaData.source_url;
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        } else if (car.media?.photo_links?.length > 0) {
          images[car.id] = car.media.photo_links[0];
        }
      }
      setFeaturedImages(images);
    };

    fetchFeaturedImages();
  }, [data]);

  const featuredCars = data.filter((car) => car?.meta?.hp_featured === "1");

  if (featuredCars.length === 0) {
    return null; // or render a placeholder
  }

  // Chunk featured cars into groups of 3
  const chunkedCars = [];
  for (let i = 0; i < featuredCars.length; i += 3) {
    chunkedCars.push(featuredCars.slice(i, i + 3));
  }

  return (
    <div className="featured-cars">
      <h2>Featured Vehicles Listings</h2>
      <Carousel
        indicators={false} // disable default indicators
        interval={5000}
        pause={false} // remove if you want to pause on hover
        className="carousel" // add a custom class if needed
        style={{ width: "100%", margin: "0 auto" }} // Make carousel full width
      >
        {chunkedCars.map((chunk, index) => (
          <Carousel.Item key={index} className="carousel-item">
            <Row>
              {chunk.map((car, idx) => (
                <Col key={idx} sm={6} className="carousel-item-col">
                  <a href={`/details/?detail_id=${car.id}`}>
                    <div className="card">
                      <img
                        src={
                          featuredImages[car.featured_media] ||
                          featuredImages[car.id]
                        }
                        alt={car.name}
                        className="card-img-top"
                      />
                      <div className="card-body">
                      <h5
  className="card-title"
  dangerouslySetInnerHTML={{ __html: car?.title?.rendered }}
></h5>
                        <p className="card-price">
                          $
                          {car?.meta?.hp_price || car?.price
                            ? formatNumber(car?.meta?.hp_price || car?.price)
                            : ""}
                        </p>
                      </div>
                    </div>
                  </a>
                </Col>
              ))}
            </Row>
          </Carousel.Item>
        ))}
      </Carousel>
      <ul className="carousel-pagination">
        {chunkedCars.map((_, index) => (
          <li
            key={index}
            className={index === activeIndex ? "active" : ""}
            onClick={() => setActiveIndex(index)}
          />
        ))}
      </ul>
    </div>
  );
};

export default FeaturedCars;
